import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import firebase from 'firebase';
import moment from 'moment';

export default function Melhorias() {
    const [servicos] = useState({
        auth: firebase.auth(),
        usuarios: firebase.firestore().collection('usuarios'),
        melhorias: firebase.firestore().collection('melhorias'),
    })
    const [mes, setMes] = useState(moment().format('MM'))
    const [ano, setAno] = useState(moment().format('YYYY'))
    const [status, setStatus] = useState('SOLICITADO')
    const [usuario, setUsuario] = useState({})
    const [melhorias, setMelhorias] = useState([])

    // Cadastro
    const [titulo, setTitulo] = useState('')
    const [tipo, setTipo] = useState('')
    const [sugestao, setSugestao] = useState('')
    const [erroTitulo, setErroTitulo] = useState(false)
    const [erroTipo, setErroTipo] = useState(false)
    const [erroSugestao, setErroSugestao] = useState(false)

    useEffect(() => {
        mensagemLoading('Carregando Empresas')
        servicos.auth.onAuthStateChanged((user) => {
            if (user) {
                servicos.usuarios.doc(user.uid).get().then((res) => {
                    setUsuario(res.data())
                })
                servicos.melhorias
                    .where('mes', '==', mes)
                    .where('ano', '==', ano)
                    .where('status', '==', 'SOLICITADO')
                    .onSnapshot((res) => {
                        const data = res.docs.map((d) => d.data())
                        setMelhorias(data)
                        Swal.close()
                    })
            }
        })

    }, {})

    function filtro() {
        if (!mes) {
            mensagemAlerta('Por favor selecione o Mes')
            return
        }
        if (!ano) {
            mensagemAlerta('Por favor selecione o Ano')
            return
        }
        mensagemLoading('Carregando cotações..')
        if (status === 'ALL') {
            servicos
                .melhorias
                .where('mes', '==', mes)
                .where('ano', '==', ano)
                .get().then((res) => {
                    const data = res.docs.map((d) => d.data())
                    setMelhorias(data)
                    Swal.close()
                })
        } else {
            servicos
                .melhorias
                .where('mes', '==', mes)
                .where('ano', '==', ano)
                .where('status', '==', status)
                .get().then((res) => {
                    const data = res.docs.map((d) => d.data())
                    setMelhorias(data)
                    Swal.close()
                })
        }


    }

    function cadastraSugestao() {
        setErroTitulo(false)
        setErroTipo(false)
        setErroSugestao(false)
        if (!titulo) {
            setErroTitulo(true)
            return
        }
        if (!tipo) {
            setErroTipo(true)
            return
        }
        if (!sugestao) {
            setErroSugestao(true)
            return
        }
        mensagemLoading('Cadsatrando Sugestão..')
        servicos.melhorias.get().then((res) => {
            servicos.melhorias.add({
                titulo: titulo,
                tipo: tipo,
                sugestao: sugestao,
                dataCadastro: moment().format('YYYY-MM-DD HH:mm'),
                ano: moment().format('YYYY'),
                mes: moment().format('MM'),
                status: 'SOLICITADO',
                codigo: 'ME00' + parseInt(res.size + 1),
                usuario: {
                    id: usuario.id,
                    nome: usuario.nome ? usuario.nome : usuario.agente,
                    email: usuario.email,
                    tipo: usuario.usuario
                }
            }).then((melhoria) => {
                servicos.melhorias.doc(melhoria.id).update({
                    id: melhoria.id
                }).then(() => {
                    mensagemSucesso('Sugestão enviada com sucesso! A equipe irá analisar sua sugestão. Para acompanhar volte a esta tela e filtre pelo seu codigo')
                })
            })
        })



    }

    const handleTitulo = (event) => {
        event.persist();
        setTitulo(event.target.value);
    }
    const handleTipo = (event) => {
        event.persist();
        setTipo(event.target.value);
    }
    const handleSugestao = (event) => {
        event.persist();
        setSugestao(event.target.value);
    }

    const handleMes = (event) => {
        event.persist();
        setMes(event.target.value);
    }
    const handleAno = (event) => {
        event.persist();
        setAno(event.target.value);
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            setTipo('')
            setTitulo('')
            setSugestao('')
        })
    }
    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">

                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">



                            {/* Content */}
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <div className="row">
                                    <div className="col-sm-6 col-lg-4 mb-4">
                                        <div className="card card-border-shadow-primary h-100">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center mb-2 pb-1">
                                                    <div className="avatar me-2">
                                                        <span className="avatar-initial rounded bg-label-info"><i className="bx bxs-file" /></span>
                                                    </div>
                                                    <h4 className="ms-1 mb-0">{melhorias.filter((d) => d.status === 'SOLICITADO').length}</h4>
                                                </div>
                                                <p className="mb-1">SOLICITADO<br /></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-4 mb-4">
                                        <div className="card card-border-shadow-primary h-100">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center mb-2 pb-1">
                                                    <div className="avatar me-2">
                                                        <span className="avatar-initial rounded bg-label-warning"><i className="bx bxs-error-circle" /></span>
                                                    </div>
                                                    <h4 className="ms-1 mb-0">{melhorias.filter((d) => d.status === 'DESENVOLVIMENTO').length}</h4>
                                                </div>
                                                <p className="mb-1">DESENVOLVIMENTO<br /></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-4 mb-4">
                                        <div className="card card-border-shadow-warning h-100">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center mb-2 pb-1">
                                                    <div className="avatar me-2">
                                                        <span className="avatar-initial rounded bg-label-success"><i className="bx bx-check" /></span>
                                                    </div>
                                                    <h4 className="ms-1 mb-0">{melhorias.filter((d) => d.status === 'FINALIZADO').length}</h4>
                                                </div>
                                                <p className="mb-1">FINALIZADOS<br /></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="row col-md-12 container-xxl">
                                        <div class="col-md-11">
                                            <h5 className="card-header">Central de Melhorias</h5>
                                        </div>
                                        <div class="col-md-1" style={{ marginTop: 20 }}>
                                            <a href='/cadastroMelhoria' type="button" class="btn btn-success">Nova</a>
                                        </div>
                                    </div>

                                    <div className="row col-md-12 container-xxl">
                                        <div class="mb-3 col-md-2">
                                            <label class="form-label" for="basic-icon-default-fullname">Mês</label>
                                            <select id="defaultSelect" className="form-select" onChange={handleMes} >
                                                <option>Selecione</option>
                                                <option value={'01'} selected={mes === '01' ? 'selected' : null}>Janeiro</option>
                                                <option value={'02'} selected={mes === '02' ? 'selected' : null}>Fevereiro</option>
                                                <option value={'03'} selected={mes === '03' ? 'selected' : null}>Março</option>
                                                <option value={'04'} selected={mes === '04' ? 'selected' : null}>Abril</option>
                                                <option value={'05'} selected={mes === '05' ? 'selected' : null}>Maio</option>
                                                <option value={'06'} selected={mes === '06' ? 'selected' : null}>Junho</option>
                                                <option value={'07'} selected={mes === '07' ? 'selected' : null}>Julho</option>
                                                <option value={'08'} selected={mes === '08' ? 'selected' : null}>Agosto</option>
                                                <option value={'09'} selected={mes === '09' ? 'selected' : null}>Setembro</option>
                                                <option value={'10'} selected={mes === '10' ? 'selected' : null}>Outubro</option>
                                                <option value={'11'} selected={mes === '11' ? 'selected' : null}>Novembro</option>
                                                <option value={'12'} selected={mes === '12' ? 'selected' : null}>Dezembro</option>
                                            </select>
                                        </div>
                                        <div class="mb-3 col-md-2">
                                            <label class="form-label" for="basic-icon-default-fullname">Ano</label>
                                            <select id="defaultSelect" className="form-select" onChange={handleAno}  >
                                                <option>Selecione</option>
                                                <option value={'2024'} selected={ano === '2024' ? 'selected' : null}>2024</option>
                                                <option value={'2025'} selected={ano === '2025' ? 'selected' : null}>2025</option>
                                                <option value={'2026'} selected={ano === '2026' ? 'selected' : null}>2026</option>
                                                <option value={'2027'} selected={ano === '2027' ? 'selected' : null}>2027</option>
                                                <option value={'2028'} selected={ano === '2028' ? 'selected' : null}>2028</option>
                                                <option value={'2029'} selected={ano === '2029' ? 'selected' : null}>2029</option>
                                                <option value={'2030'} selected={ano === '2030' ? 'selected' : null}>2030</option>
                                            </select>
                                        </div>
                                        <div class="mb-3 col-md-2">
                                            <label class="form-label" for="basic-icon-default-fullname">Status</label>
                                            <select id="defaultSelect" className="form-select" onChange={handleAno}  >
                                                <option>Selecione</option>
                                                <option value={'SOLICITADO'} >Solicitado</option>
                                                <option value={'DESENVOLVIMENTO'} >Desenvolvimento</option>
                                                <option value={'FINALIZADO'} >Finalizado</option>
                                                <option value={'ALL'} >Todas</option>
                                            </select>
                                        </div>
                                        <div style={{ marginTop: 30 }} class="mb-3 col-md-2">
                                            <button onClick={() => filtro()} type="submit" class="btn btn-info">Filtrar</button>
                                        </div>
                                    </div>
                                    <div className="table-responsive text-nowrap">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Solicitante</th>
                                                    <th>Titulo</th>
                                                    <th>Descrição</th>
                                                    <th>Status</th>
                                                    <th>Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-border-bottom-0">
                                                {melhorias.map((melhoria) =>
                                                    <tr key={melhoria.id}>
                                                        <td>{melhoria.codigo}</td>
                                                        <td>{melhoria.usuario.nome}</td>
                                                        <td>{melhoria.titulo}</td>
                                                        <td>{melhoria.sugestao.substr(0, 50)}</td>
                                                        <td>
                                                            {melhoria.status === 'SOLICITADO' ?
                                                                <span class="badge bg-label-info me-1">Solicitado</span>
                                                                : melhoria.status === 'DESENVOLVIMENTO' ?
                                                                    <span class="badge bg-label-warning me-1">Desenvolvimento</span>
                                                                    :
                                                                    <span class="badge bg-label-success me-1">Finalizado</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            <button onClick={() => window.location = '/cadastroMelhoria?c=' + melhoria.id} type="button" className="btn rounded-pill btn-icon">
                                                                <span className="tf-icons bx bx-search" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                                {melhorias.length === 0 ?
                                                    <p style={{ textAlign: 'center', padding: 10 }} >Sem melhorias cadastradas</p>
                                                    :
                                                    null
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}